import { ActivationColumn } from './ActivationColumn';
import { BatteryColumn } from './BatteryColumn';
import { ChartColumn } from './ChartColumn';
import { HeartbeatColumn } from './HeartbeatColumn';
import { InfoReportColumn } from './InfoReportColumn';
import { LastMessageColumn } from './LastMessageColumn';
import { LocationColumn } from './LocationColumn';
import { MessagesCountColumn } from './MessagesCountColumn';
import { MovementColumn } from './MovementColumn';
import { NonMovementColumn } from './NonMovementColumn';
import { OnlineColumn } from './OnlineColumn';
import { SOSColumn } from './SOSColumn';
import { ServerACKColumn } from './ServerACKColumn';
import { ShippingColumn } from './ShippingColumn';
import { TagsColumn } from './TagsColumn';

export default {
  onlineColumn: OnlineColumn,
  locationColumn: LocationColumn,
  batteryColumn: BatteryColumn,
  messagesCountColumn: MessagesCountColumn,
  activationColumn: ActivationColumn,
  chartColumn: ChartColumn,
  shippingColumn: ShippingColumn,
  tagsColumn: TagsColumn,
  nonMovementColumn: NonMovementColumn,
  movementColumn: MovementColumn,
  heartbeatColumn: HeartbeatColumn,
  infoReportColumn: InfoReportColumn,
  serverACKColumn: ServerACKColumn,
  sosColumn: SOSColumn,
  lastMessageColumn: LastMessageColumn,
};
